var React = require('react');

function IconTask (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"cls-1","d":"M16.67 31a1.6 1.6 0 0 1-1.17-.49l-9.33-9.33a1.64 1.64 0 0 1 0-2.34l2.66-2.66a1.64 1.64 0 0 1 2.34 0l5.5 5.5L28.83 9.51a1.64 1.64 0 0 1 2.34 0l2.66 2.66a1.64 1.64 0 0 1 0 2.34l-16 16a1.6 1.6 0 0 1-1.16.49zM37.81 2.2a7.23 7.23 0 0 0-5.3-2.2H7.5a7.23 7.23 0 0 0-5.3 2.2A7.22 7.22 0 0 0 0 7.5v25a7.22 7.22 0 0 0 2.2 5.3A7.23 7.23 0 0 0 7.5 40h25a7.51 7.51 0 0 0 7.5-7.5v-25a7.23 7.23 0 0 0-2.19-5.3z"}));
}

IconTask.defaultProps = {"viewBox":"0 0 40.01 40.01"};

module.exports = IconTask;

IconTask.default = IconTask;
